import { render, staticRenderFns } from "./EditLeadItemSidebar.vue?vue&type=template&id=575dae0f&"
import script from "./EditLeadItemSidebar.vue?vue&type=script&lang=js&"
export * from "./EditLeadItemSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports